import { Component, Input, OnInit } from '@angular/core';
import { InOrder } from 'src/models/InOrder';
import * as moment from 'moment';
import { translateInOrderEntrySource } from 'src/app/pages/in/in-order-helper';

@Component({
  selector: 'app-in-details-buy-order',
  templateUrl: './in-details-buy-order.component.html',
  styleUrls: ['./in-details-buy-order.component.scss']
})
export class InDetailsBuyOrderComponent implements OnInit {

  @Input() data: InOrder;

  constructor() { }

  ngOnInit(): void {}

  timestampToDate(timestamp) {
    return moment(timestamp).format('DD/MM/YYYY - HH:mm');
  }

  translateEntrySource(entrySource: string): string {
    return translateInOrderEntrySource(entrySource);
  }

}
